import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Technologies from '../components/Technologies';
import Services from '../components/Services';
import WhyChooseUs from '../components/WhyChooseUs';
import Pricing from '../components/Pricing';
import AboutUs from '../components/AboutUs';
import LatestProject from '../components/LatestProject';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      offset: 100
    });
  }, []);

  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Technologies />
      <Services />
      <WhyChooseUs />
      <Pricing />
      <AboutUs />
      <LatestProject />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;

